module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1005.2f1632e2.png";